import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import SEO from '../components/SEO';

const BeamrPage = () => {
  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://monkstack.com"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Products",
        "item": "https://monkstack.com/beamr"
      },
      {
        "@type": "ListItem",
        "position": 3,
        "name": "Beamr",
        "item": "https://monkstack.com/beamr"
      }
    ]
  };

  const productSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "Beamr",
    "description": "Real Estate's Lead Engine - Your AI Sales Desk. Beamr is an AI-powered sales solution for the real estate industry.",
    "url": "https://beamr.ai",
    "applicationCategory": "BusinessApplication",
    "operatingSystem": "Web",
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "USD"
    }
  };

  return (
    <div className="App">
      <SEO
        title="Beamr - Real Estate's Lead Engine | AI Sales Desk"
        description="Beamr - Real Estate's Lead Engine. Your AI Sales Desk. Transform your real estate sales with AI-powered lead generation and management."
        url="https://monkstack.com/beamr"
        image="https://monkstack.com/img/beamr/logo-plain.png"
        structuredData={[breadcrumbSchema, productSchema]}
      />
      <Navbar />
      
      {/* Landing Page */}
      <section className="beamr-landing">
        <div className="beamr-particles"></div>
        <div className="beamr-landing-content">
          <div className="beamr-introducing">Introducing</div>
          
          <div className="beamr-brand-section">
            <div className="beamr-brand-name">beamr.</div>         
          </div>
          
          <h1 className="beamr-hero-title">
            <span className="beamr-title-line beamr-title-white">Real Estate's Lead</span>
            <span className="beamr-title-line beamr-title-purple">Engine</span>
            <span className="beamr-title-line beamr-title-white">Your AI Sales Desk</span>
          </h1>
          
          <div className="beamr-cta-section">
            <a 
              href="https://beamr.ai/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="beamr-visit-btn"
            >
              Visit
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default BeamrPage;

